import script from "./Deletion-Policy.vue?vue&type=script&setup=true&lang=js"
export * from "./Deletion-Policy.vue?vue&type=script&setup=true&lang=js"

import "./Deletion-Policy.vue?vue&type=style&index=0&id=5d434788&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d434788"]])

export default __exports__